import getByDocuments from 'src/components/pages/info/document/index/_constants/documents-by'
import getKgDocuments from 'src/components/pages/info/document/index/_constants/documents-kg'
import getKzDocuments from 'src/components/pages/info/document/index/_constants/documents-kz'
import getPdDocuments from 'src/components/pages/info/document/index/_constants/documents-pd'
import type { DocumentItem } from 'src/components/pages/info/document/index/types'

type Translate = (_text: string) => string

export default function getDocumentsByCountry(
  staticPath: string,
  countryIso: string,
  translate: Translate,
): DocumentItem[] {
  if (countryIso === 'BY') {
    return getByDocuments(staticPath, translate)
  }

  if (countryIso === 'KZ') {
    return getKzDocuments(staticPath, translate)
  }

  if (countryIso === 'KG') {
    return getKgDocuments(staticPath, translate)
  }

  return getPdDocuments(staticPath, translate)
}
